import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';


import Serverurl from "./Apiurl";

export default class VendorLedgerReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
vendorId: "",
status: "",
      vendorarrauto: [],
      selectedVendor: null,
reportData: [],
openExportDialog: false,
      page: 0,
      rowsPerPage: 50,
      totalRecords: 0,
projectId: "",
projectarrauto: [],
selectedProject: null,
      loading: false,
      error: ""
    };
  }
  getProjectIdFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("vendorid");
};
  componentDidMount() {
	   if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Vendor Ledger";   
			 this.props.parentsCallback(
           strname
        );
   const vendorid = this.getProjectIdFromURL();

  if (vendorid) {
    this.setState(
      { vendorid },
      () => {
       
        this.loadVendorById(vendorid); 
      }
    );
  } else {
    this.fetchReport();
  }
  }
  
  loadVendorById = (vendorid) => {
  axios
    .get(Serverurl + "ajaxvendor.php", {
      params: {
        action: "getall",
        vm_id: vendorid
      }
    })
    .then((res) => {
      const data = res.data?.[0];
 if (data) {
        this.setState({vendorId:data.vm_id,
          selectedVendor: {
            title: data.vm_vendorname,
            vm_id: data.vm_id
          }
        },()=>{ this.fetchReport();});
      }
    });
};
  onloadProjectBind = (event) => {
  axios
    .get(
      Serverurl +
        "ajaxprojects.php?action=getallprojectautoextender&projectname=" +
        encodeURIComponent(event.target.value)
    )
    .then((res) => {
      const list = (res.data || []).map((x) => ({
        title: x.pj_projectname,
        pj_id: x.pj_id
      }));

      this.setState({
        projectarrauto: list
      });
    });
};
onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};
  fetchReport = () => {
    this.setState({ loading: true });
axios.get(Serverurl +
"ajaxvendor.php?action=vendorledgerreport" +
"&projectid=" + this.state.projectId +
"&vendorid=" + this.state.vendorId +
"&ts_status=" + this.state.status +
"&fromdate=" + this.state.fromDate.format("YYYY-MM-DD") +
"&todate=" + this.state.toDate.format("YYYY-MM-DD") +
"&StartIndex=" + (this.state.page * this.state.rowsPerPage) +
"&PageSize=" + this.state.rowsPerPage +
"&sorting=LedgerDate desc"
)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];

        this.setState({
          reportData: data,
          totalRecords: data?.[0]?.count || 0,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: "Error loading report"
        });
      });
  };
handlePageChange = (e, newPage) => {
    this.setState({ page: newPage }, () => this.fetchReport());
  };

  handleRowsChange = (e) => {
    this.setState(
      {
        rowsPerPage: parseInt(e.target.value, 10),
        page: 0
      },
      () => this.fetchReport()
    );
  };
 onloadVendorBind = (event) => {
axios.get(
  Serverurl +
    "ajaxvendor.php?action=vendorautoextender&vendorname=" +
    encodeURIComponent(event.target.value)
)
      .then((res) => {
        const list = (res.data || []).map((x) => ({
          title: x.vm_vendorname,
          vm_id: x.vm_id
        }));

        this.setState({ vendorarrauto: list });
      });
  };

  onVendorChange = (event, value) => {
    this.setState({
      selectedVendor: value,
      vendorId: value ? value.vm_id : ""
    });
  };
  exportExcel = () => {
  const { reportData } = this.state;

  if (!reportData.length) return alert("No data to export");

const excelData = reportData.map((r) => ({
  Project: r.ProjectName,
  Vendor: r.VendorName,
  Type: r.Type,
  CostAmount: r.CostAmount,
  PaidAmount: r.PaidAmount,
  Balance: r.Balance
}));
const totalCost = reportData.reduce(
  (sum, r) => sum + (parseFloat(r.CostAmount) || 0),
  0
);

const totalPaid = reportData.reduce(
  (sum, r) => sum + (parseFloat(r.PaidAmount) || 0),
  0
);

const totalBalance = reportData.reduce(
  (sum, r) => sum + (parseFloat(r.Balance) || 0),
  0
);
excelData.push({
  Project: "",
  Vendor: "",
  Type: "TOTAL",
  CostAmount: totalCost.toFixed(2),
  PaidAmount: totalPaid.toFixed(2),
  Balance: totalBalance.toFixed(2)
});

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Vendor Ledger");

  const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  saveAs(new Blob([buffer]), "Vendor_Ledger_Report.xlsx");

  this.setState({ openExportDialog: false });
};
downloadPDF = () => {
  const { reportData } = this.state;

  const doc = new jsPDF("l", "mm", "a4");

  doc.setFontSize(14);
  doc.text("Vendor Ledger Report", 14, 15);
const headers = [[
  "Project",
  "Vendor",
  "Type",
  "Cost Amount",
  "Paid Amount",
  "Balance"
]];
const rows = reportData.map((r) => [
  r.ProjectName,
  r.VendorName,
  r.Type,
  r.CostAmount,
  r.PaidAmount,
  r.Balance
]);

const totalCost = reportData.reduce(
  (sum, r) => sum + (parseFloat(r.CostAmount) || 0),
  0
);

const totalPaid = reportData.reduce(
  (sum, r) => sum + (parseFloat(r.PaidAmount) || 0),
  0
);

const totalBalance = reportData.reduce(
  (sum, r) => sum + (parseFloat(r.Balance) || 0),
  0
);

rows.push([
  "",
  "",
  "TOTAL",
  totalCost.toFixed(2),
  totalPaid.toFixed(2),
  totalBalance.toFixed(2)
]);

  autoTable(doc, {
    head: headers,
    body: rows,
    startY: 25
  });

  doc.save("Vendor_Ledger_Report.pdf");

  this.setState({ openExportDialog: false });
};
 render() {
  const reportData = Array.isArray(this.state.reportData)
    ? this.state.reportData
    : [];

  const totalCost = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.CostAmount) || 0),
    0
  );

  const totalPaid = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.PaidAmount) || 0),
    0
  );

  const totalBalance = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.Balance) || 0),
    0
  );

  return (
    <div>
      <div>
      

      
          <div className="searchmaster">
            <ul>
              <li>
                <p>From Date</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>  <DatePicker className="inputcntlparent"
                  disableFuture
                  value={this.state.fromDate}
                  onChange={(v) => this.setState({ fromDate: v })}
                  slotProps={{ textField: { size: "small" } }}
                  format="DD/MM/YYYY"
                /></LocalizationProvider>
              </li>

              <li>
                <p>To Date</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>  <DatePicker className="inputcntlparent"
                  disableFuture
                  value={this.state.toDate}
                  onChange={(v) => this.setState({ toDate: v })}
                  slotProps={{ textField: { size: "small" } }}
                  format="DD/MM/YYYY"
                /></LocalizationProvider>
              </li>
<li>
  <p>Project</p>

  <Autocomplete className="inputcntlparent"
    options={this.state.projectarrauto}
    value={this.state.selectedProject}
    onChange={this.onProjectChange}
    getOptionLabel={(option) => option.title || ""}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        placeholder="Search Project"
        onChange={this.onloadProjectBind}
      />
    )}
  />
</li>
              <li>
                <p>Vendor</p>
                <Autocomplete className="inputcntlparent"
                  options={this.state.vendorarrauto}
                  value={this.state.selectedVendor}
                  onChange={this.onVendorChange}
                  getOptionLabel={(o) => o.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Search Vendor"
                      onChange={this.onloadVendorBind}
                    />
                  )}
                />
              </li>
			  
			  

              <li>
                <p>&nbsp;</p>
               <p> <Button
                  variant="contained"  className="exportbtn"
                  onClick={this.fetchReport} endIcon={<SearchIcon />}
                >
                  Search
                </Button> <Button
                  variant="contained"
                  className="exportbtn"
                  onClick={() =>
                    this.setState({ openExportDialog: true })
                  }
                  
                >
                  Export
                </Button></p>
              </li>

            </ul>
          </div>


        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
			   <TableCell>Date</TableCell>
                <TableCell>Project</TableCell>
                <TableCell>Vendor</TableCell>
                <TableCell>Type</TableCell>        
                <TableCell align="right">Cost Amount</TableCell>
                <TableCell align="right">Paid Amount</TableCell>
                <TableCell align="right">Balance</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {reportData.map((r, i) => (
                <TableRow key={i}>
				  <TableCell>
    {r.LedgerDate
      ? dayjs(r.LedgerDate).format("DD/MM/YYYY")
      : ""}
  </TableCell>
                  <TableCell>{r.ProjectName}</TableCell>

                  <TableCell>{r.VendorName}</TableCell>

                  <TableCell>{r.Type}</TableCell> 

                  <TableCell align="right">
                    Rs.
                    {Number(r.CostAmount || 0).toLocaleString("en-IN")}
                  </TableCell>

                  <TableCell align="right">
                    Rs.
                    {Number(r.PaidAmount || 0).toLocaleString("en-IN")}
                  </TableCell>

                  <TableCell align="right">
                    <b>
                      Rs.
                      {Number(r.Balance || 0).toLocaleString("en-IN")}
                    </b>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell colSpan={4} align="right">
                  <b>TOTAL</b>
                </TableCell>

                <TableCell align="right">
                  <b>
                     Rs.{totalCost.toLocaleString("en-IN")}
                  </b>
                </TableCell>

                <TableCell align="right">
                  <b>
                     Rs. {totalPaid.toLocaleString("en-IN")}
                  </b>
                </TableCell>

                <TableCell align="right">
                  <b>
                     Rs. {totalBalance.toLocaleString("en-IN")}
                  </b>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <TablePagination
		   rowsPerPageOptions={[50, 100, 150, 200, 250]}  
            component="div"
            count={this.state.totalRecords}
            page={this.state.page}
            rowsPerPage={this.state.rowsPerPage}
            onPageChange={this.handlePageChange}
            onRowsPerPageChange={this.handleRowsChange}
          />

          <Dialog
            open={this.state.openExportDialog}
            onClose={() =>
              this.setState({ openExportDialog: false })
            }
          >
            <DialogTitle>Export Vendor Ledger</DialogTitle>

            <DialogContent>
              <div
                style={{
                  display: "flex",
                  gap: 15,
                  justifyContent: "center",
                  marginTop: 10
                }}
              >
                <Button
                  variant="contained"
                  onClick={this.exportExcel}
                  sx={{ backgroundColor: "#2e7d32" }}
                >
                  Excel
                </Button>

                <Button
                  variant="contained"
                  onClick={this.downloadPDF}
                  sx={{ backgroundColor: "#d32f2f" }}
                >
                  PDF
                </Button>
              </div>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() =>
                  this.setState({ openExportDialog: false })
                }
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </TableContainer>
      </div>
    </div>
  );
}
}

